<!-- <div class="clearfix content">
    <div class="clearfix bi-reponsive">
        <div class="clearfix logout-container" style="position: fixed;top: 0;right: 0;left: 0;bottom: 0;">
            <div class="clearfix logout-content request  report-filter">
                <br>
                <div>
                    <div class="er-404">
                        <img src="./assets/images/session-timeout.svg" alt="Session expired!" class="erImg">
                        <p class="sentral bigText">{{'SESSIONTIMEOUT.welcomeBack'| translate}}</p>
                        <p class="sentral smallText">{{'SESSIONTIMEOUT.sessionTimeout'| translate}}<br/>{{'SESSIONTIMEOUT.timeoutPage'| translate}}<br/>{{'SESSIONTIMEOUT.timeout'| translate}}</p>
                        <button class="btn-primary" *ngIf="!http.loggedIn"  clickable (click)="gotoDashboard()">{{'SESSIONTIMEOUT.returnHomePage'| translate}}</button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div> -->


<div class="unauth-container">
    <div class="unauth-container_header">
      <svg class="logo" xmlns="http://www.w3.org/2000/svg" width="100" height="52" viewBox="0 0 139 52">
      <g id="Smart_Logo_with_Text" data-name="Smart Logo with Text" transform="translate(915 10555)">
        <text id="SMART_BANK" data-name="SMART BANK" transform="translate(-852 -10535)" fill="#00a10b" font-size="20"
          font-family="Montserrat-ExtraBold, Montserrat" font-weight="800">
          <tspan x="0" y="0">SMART</tspan>
          <tspan x="0" y="26">BANK</tspan>
        </text>
        <g id="Rectangle_3516" data-name="Rectangle 3516" transform="translate(-915 -10555)" fill="none"
          stroke="#00a10b" stroke-width="12">
          <rect width="52" height="52" stroke="none" />
          <rect x="6" y="6" width="40" height="40" fill="none" />
        </g>
      </g>
    </svg>
    </div>
    <div class="unauth-container_content">
      <img src="./assets/images/session-timeout.svg" alt="Session expired!" />
      <h4>{{'SESSIONTIMEOUT.welcomeBack'| translate}}</h4>
      <span>{{'SESSIONTIMEOUT.sessionTimeout'| translate}}</span>
      <button class="btn-primary" (click)="gotoWelcomePage()">{{'SESSIONTIMEOUT.returnHomePage'| translate}}</button>
    </div>
    <div class="card-bg-selector">
      <div class="card-bg-selector-holder">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="XMinYMin meet"
          viewBox="0 0 1886.595 448.599"
        >
          <g
            id="Group_10459"
            data-name="Group 10459"
            transform="translate(0.363 0.495)"
          >
            <path
              id="Path_10139"
              data-name="Path 10139"
              d="M2097.957,431.03c-123.8-65.614-733.053-328.646-1183.248-97.705C561.034,514.753,417.763,5.878,211.959,223.064"
              transform="translate(-211.959 -65.833)"
              fill="none"
              stroke="#00a10bB0"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10140"
              data-name="Path 10140"
              d="M2097.784,413.294c-139.626-60.274-721.6-293.927-1169.014-84.959-353.1,164.919-509.155-313.456-716.553-97.79"
              transform="translate(-211.786 -62.141)"
              fill="none"
              stroke="#459839"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10141"
              data-name="Path 10141"
              d="M2097.611,395.641c-155.447-54.932-710.239-259.274-1154.78-72.212C590.233,471.8,421.469,23.964,212.476,238.109"
              transform="translate(-211.613 -58.534)"
              fill="none"
              stroke="#47993a"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10142"
              data-name="Path 10142"
              d="M2097.438,378.087c-171.265-49.59-698.968-224.7-1140.548-59.463C604.72,450.4,423.322,33.149,212.734,245.773"
              transform="translate(-211.44 -55.026)"
              fill="none"
              stroke="#4a9b3a"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10143"
              data-name="Path 10143"
              d="M2097.264,360.648C1910.183,316.4,1409.478,170.431,970.945,313.933,619.135,429.057,425.175,42.45,212.993,253.553"
              transform="translate(-211.267 -51.634)"
              fill="none"
              stroke="#4c9d3b"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10144"
              data-name="Path 10144"
              d="M2097.092,343.347C1894.2,304.443,1420.4,187.5,985,309.379c-351.523,98.4-557.975-257.492-771.75-47.909"
              transform="translate(-211.094 -48.379)"
              fill="none"
              stroke="#4e9e3b"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10145"
              data-name="Path 10145"
              d="M2096.918,326.208c-218.708-33.562-665.676-121.593-1097.864-21.22-351.3,81.587-570.176-243.5-785.545-35.438"
              transform="translate(-210.921 -45.287)"
              fill="none"
              stroke="#50a03c"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10146"
              data-name="Path 10146"
              d="M2096.746,309.266c-234.518-28.221-654.736-87.48-1083.64-8.474C661.97,365.473,430.731,71.282,213.769,277.824"
              transform="translate(-210.747 -42.39)"
              fill="none"
              stroke="#53a23c"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10147"
              data-name="Path 10147"
              d="M2096.572,292.557c-250.326-22.879-643.859-53.513-1069.417,4.274C676.128,344.5,432.583,81.312,214.027,286.334"
              transform="translate(-210.575 -39.727)"
              fill="none"
              stroke="#55a43c"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10148"
              data-name="Path 10148"
              d="M2096.4,276.132c-266.133-17.537-633.041-19.7-1055.2,17.021-350.964,30.532-606.77-201.527-826.918,1.973"
              transform="translate(-210.401 -37.348)"
              fill="none"
              stroke="#57a53d"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10149"
              data-name="Path 10149"
              d="M2096.226,260.051c-281.937-12.193-622.268,13.94-1040.977,29.769-350.937,13.268-618.963-187.536-840.705,14.444"
              transform="translate(-210.228 -35.314)"
              fill="none"
              stroke="#59a73d"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10150"
              data-name="Path 10150"
              d="M2096.053,244.384c-297.739-6.851-611.528,47.408-1026.759,42.516C718.355,282.767,438.138,113.356,214.8,313.814"
              transform="translate(-210.055 -33.693)"
              fill="none"
              stroke="#5ca93e"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10151"
              data-name="Path 10151"
              d="M2095.88,229.21c-313.539-1.511-600.807,80.7-1012.543,55.262-350.956-21.679-643.349-159.553-868.276,39.385"
              transform="translate(-209.883 -32.564)"
              fill="none"
              stroke="#5eaa3e"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10152"
              data-name="Path 10152"
              d="M2095.707,216.217c-329.337,3.831-590.093,113.81-998.33,68.012C746.4,244.852,441.839,138.665,215.32,336.082"
              transform="translate(-209.709 -33.617)"
              fill="none"
              stroke="#60ac3e"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10153"
              data-name="Path 10153"
              d="M2095.534,207.8c-345.134,9.173-579.372,146.744-984.117,80.759C760.425,231.338,443.69,156.99,215.579,352.886"
              transform="translate(-209.536 -39.25)"
              fill="none"
              stroke="#62ae3f"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10154"
              data-name="Path 10154"
              d="M2095.361,199.389C1734.434,213.906,1526.731,378.9,1125.455,292.9,774.469,217.674,445.541,175.314,215.837,369.69"
              transform="translate(-209.363 -44.882)"
              fill="none"
              stroke="#64af3f"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10155"
              data-name="Path 10155"
              d="M2095.188,190.975c-376.719,19.859-557.852,212.1-955.7,106.254-350.948-93.372-692.1-103.59-923.393,89.265"
              transform="translate(-209.19 -50.514)"
              fill="none"
              stroke="#67b140"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10156"
              data-name="Path 10156"
              d="M2095.015,182.561c-392.509,25.2-547.028,244.543-941.491,119C802.656,189.9,449.241,211.964,216.354,403.3"
              transform="translate(-209.017 -56.147)"
              fill="none"
              stroke="#69b340"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10157"
              data-name="Path 10157"
              d="M2094.842,174.148C1686.544,204.69,1558.7,450.984,1167.556,305.9,816.822,175.8,451.091,230.29,216.613,420.1"
              transform="translate(-208.844 -61.779)"
              fill="none"
              stroke="#6bb441"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10158"
              data-name="Path 10158"
              d="M2094.668,165.734c-424.083,35.884-525.2,309-913.083,144.5C831.049,161.567,452.94,248.615,216.872,436.907"
              transform="translate(-208.67 -67.411)"
              fill="none"
              stroke="#6db641"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10159"
              data-name="Path 10159"
              d="M2094.5,157.32c-439.867,41.226-514.168,341.044-898.881,157.243C845.347,147.218,454.789,266.94,217.13,453.711"
              transform="translate(-208.498 -73.043)"
              fill="none"
              stroke="#70b841"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10160"
              data-name="Path 10160"
              d="M2094.322,148.906c-455.649,46.57-503.058,372.99-884.681,169.99-349.921-186.134-753-33.632-992.252,151.619"
              transform="translate(-208.324 -78.676)"
              fill="none"
              stroke="#72ba42"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10161"
              data-name="Path 10161"
              d="M2094.149,140.492c-471.429,51.912-491.858,404.849-870.482,182.74C874.176,118.212,458.488,303.59,217.647,487.319"
              transform="translate(-208.151 -84.308)"
              fill="none"
              stroke="#74bb42"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10162"
              data-name="Path 10162"
              d="M2093.976,132.079c-487.207,57.252-480.565,436.636-856.287,195.486C888.716,103.581,460.336,321.914,217.906,504.123"
              transform="translate(-207.978 -89.94)"
              fill="none"
              stroke="#76bd43"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10163"
              data-name="Path 10163"
              d="M2093.8,123.665C1590.82,186.259,1624.625,592.037,1251.711,331.9,903.344,88.883,462.184,340.238,218.164,520.927"
              transform="translate(-207.805 -95.572)"
              fill="none"
              stroke="#79bf43"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10164"
              data-name="Path 10164"
              d="M2093.63,115.251c-518.757,67.936-457.7,500.069-827.9,220.981-347.67-262.1-801.7,22.332-1047.307,201.5"
              transform="translate(-207.632 -101.205)"
              fill="none"
              stroke="#7bc044"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
            <path
              id="Path_10165"
              data-name="Path 10165"
              d="M2093.457,106.837c-534.529,73.28-446.12,531.742-813.709,233.728C932.866,59.339,465.881,376.888,218.682,554.535"
              transform="translate(-207.459 -106.837)"
              fill="none"
              stroke="#7dc244"
              stroke-miterlimit="10"
              stroke-width="1"
            ></path>
          </g>
        </svg>
      </div>
    </div>
  </div>
  